import React, { useState } from 'react';
import { Center, ChakraProvider, DarkMode, VStack } from '@chakra-ui/react';
import Event from './components/Event';
import ExpCard from './components/ExpCard';

const App = () => {
  const ex_job = [
    {
      k: 1,
      name: '전사',
      hp: 14000,
      mp: 3500,
    },
    {
      k: 2,
      name: '도적',
      hp: 11000,
      mp: 6000,
    },
    {
      k: 3,
      name: '마법사',
      hp: 10000,
      mp: 11000,
    },
    {
      k: 4,
      name: '성직자',
      hp: 11000,
      mp: 12000,
    },
    {
      k: 5,
      name: '무도가',
      hp: 14000,
      mp: 6000,
    },
  ];

  const pro_job = [
    {
      k: 11,
      name: '전사',
      hp: 17000,
      mp: 5000,
    },
    {
      k: 22,
      name: '도적',
      hp: 13000,
      mp: 7000,
    },
    {
      k: 33,
      name: '마법사',
      hp: 12000,
      mp: 13000,
    },
    {
      k: 44,
      name: '성직자',
      hp: 13000,
      mp: 14000,
    },
    {
      k: 55,
      name: '무도가',
      hp: 16000,
      mp: 7000,
    },
  ];

  const [targetype, setTargetType] = useState('');
  const [targetValue, setTargetValue] = useState({});

  const handleEventClick = (type, value) => {
    setTargetType(type);
    setTargetValue(value);
  };

  return (
    <ChakraProvider>
      <VStack className='app'>
        <Center>
          <VStack m={4}>
            <ExpCard type={targetype} value={targetValue} />
            <Event data={ex_job} title={'전직'} onClick={handleEventClick} />
            <Event data={pro_job} title={'승급'} onClick={handleEventClick} />
          </VStack>
        </Center>
      </VStack>
    </ChakraProvider>
  );
};

export default App;
